import { render, staticRenderFns } from "./MntCategory.vue?vue&type=template&id=08287eb5&"
import script from "./MntCategory.vue?vue&type=script&lang=js&"
export * from "./MntCategory.vue?vue&type=script&lang=js&"
import style0 from "./MntCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports